import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// CREATE 
export const createMoodCheckin = async (user, moodData) => {
  try {
    const payload = {
      user_id: user?.id,
      current_mood: moodData.currentMood,
      energy_level: moodData.energyLevel,
      notes: moodData.notes || ""
    };

    const response = await axios.post(
      `${API_BASE_URL}/mood-checkin`,
      payload
    );

    return response;
  } catch (error) {
    console.error("Error creating mood check-in:", error);
    return null;
  }
};

// GET 
export const getMoodCheckins = async (userId) => {
  try {
    const response = await axios.get(
     `${API_BASE_URL}/mood-checkins/${userId}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching mood check-ins:", error);
    return null;
  }
};